import { create } from 'zustand';
import { usersApi } from '@/api';

const useUserStore = create((set) => ({
  // State
  users: [],
  loading: false,
  error: null,

  // Actions
  fetchUsers: async (params = {}) => {
    set({ loading: true, error: null });
    try {
      const data = await usersApi.list(params);
      set({ users: data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  createUser: async (data) => {
    set({ loading: true, error: null });
    try {
      const newUser = await usersApi.create(data);
      set((state) => ({
        users: [...state.users, newUser],
        loading: false,
      }));
      return newUser;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  updateUser: async (id, data) => {
    set({ loading: true, error: null });
    try {
      const updated = await usersApi.update(id, data);
      set((state) => ({
        users: state.users.map((u) => (u.id === id ? updated : u)),
        loading: false,
      }));
      return updated;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  deleteUser: async (id) => {
    set({ loading: true, error: null });
    try {
      await usersApi.delete(id);
      set((state) => ({
        users: state.users.map((u) =>
          u.id === id ? { ...u, is_active: false } : u
        ),
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },
}));

export default useUserStore;
